import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 导入 MavonEditor
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 使用 MavonEditor
app.use(mavonEditor)
app.use(router)
// 使用 Element Plus 并设置中文语言环境，只需要调用一次
app.use(ElementPlus, { locale: zhCn });
app.mount('#app')
